// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  formList:[],
  formPage:1,
  formSize:10,
  formTotal:0,
  formById:{},
  formModalType:"create",
  formModalVisible:false,
  currentForm:{},
  getFormListPending: false,
  getFormListError: null,
  submitFormPending: false,
  submitFormError: null,
  deleteFormPending: false,
  deleteFormError: null,
  formAttrList:[],
  formAttrPage:1,
  formAttrSize:10,
  formAttrTotal:0,
  formAttrById:{},
  formAttrModalType:"create",
  formAttrModalVisible:false,
  currentFormAttr:{},
  getFormAttrListPending: false,
  getFormAttrListError: null,
  submitFormAttrPending: false,
  submitFormAttrError: null,
  deleteFormAttrPending: false,
  deleteFormAttrError: null,
  formSubmitList:[],
  formSubmitPage:1,
  formSubmitSize:10,
  formSubmitTotal:0,
  formSubmitById:{},
  formSubmitModalType:"create",
  formSubmitModalVisible:false,
  currentFormSubmit:{},
  getFormSubmitListPending: false,
  getFormSubmitListError: null,
  submitFormSubmitPending: false,
  submitFormSubmitError: null,
  deleteFormSubmitPending: false,
  deleteFormSubmitError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/formedit/redux/initialState.js